<template>
  <!-- <LayoutIndex/> -->
  <el-config-provider :locale="zhCn">
      <!-- 注意在嵌套路由中使用 keep-alive -->
    <router-view  v-slot="{ Component }">
      <keep-alive :include="['LayoutIndex']">
        <component :is="Component" />
      </keep-alive>
    </router-view >
  </el-config-provider>
</template>
<script setup lang="ts">
// import LayoutIndex from "./views/layout/Index.vue";
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// 具体配置在子路由中定义 LayoutMain.vue
// const route = useRoute()
// const cachedComponents = computed(() => {
//   const routes = route.matched
//   console.log("cachedComponents routes", routes)
//   let arr = routes.filter(route => route.meta.keepAlive).map(route => route.name)
//   console.log("cachedComponents", arr)
//   return arr
// })
</script>
<style lang='postcss'>
body,
html {
  width: 100%;
  /* height: 100%; */
  /* overflow-y: hidden !important; */
  overflow-x: hidden !important;
  background: #fbfbfb;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC,
    Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei,
    sans-serif !important;
  font-size: 15px;
}

body {
  overflow-y: hidden !important;
}

#app {
  width: 100%;
  height: 100%;
}
</style>
